import React, { useCallback, useState, Fragment } from 'react'

import {
	useFormComponents,
	formValidate,
} from '../../../utils/wordpress/fetchForm'

import { useForm } from 'react-hook-form'

import {
	motion,
	AnimatePresence,
	useScroll,
	useTransform,
} from 'framer-motion/dist/framer-motion'

import { Title } from '../../../components/main'
import { Input, TextArea, Button } from '../../../components/form'

import './Contato.scss'
import { useMediaQuery } from 'react-responsive'

const InputWrapper = ({ children, errorMessage, name, placeholder }) => {
	return (
		<Fragment>
			<div data-name={name} className="contato__input">
				<AnimatePresence>
					{children}
					{placeholder ? (
						<motion.label key={name + 'Label'} htmlFor={name}>
							{placeholder}
						</motion.label>
					) : (
						<></>
					)}
					{errorMessage ? (
						<motion.span
							initial={{
								opacity: 0,
								y: -10,
							}}
							animate={{
								opacity: 1,
								y: 0,
							}}
							exit={{
								opacity: 0,
								y: -10,
							}}
							key={name + 'Error'}
						>
							{errorMessage}
						</motion.span>
					) : (
						<></>
					)}
				</AnimatePresence>
			</div>
		</Fragment>
	)
}

export function Contato({ data, refMain }) {
	const isMobile = useMediaQuery({ query: '(max-width: 1000px)' })
	const { scrollYProgress } = useScroll({
		target: refMain,
		offset: !isMobile ? ['0.225 1', '1.2 0'] : ['0.295 1', '1.2 0'],
	})
	const parallax = useTransform(scrollYProgress, [0, 1], [0, 1000])

	const formId = data.contactId
	const [loading, setLoading] = useState(false)
	const [success, setSuccess] = useState(false)
	const [components, error] = useFormComponents(formId)
	const {
		register,
		handleSubmit,
		setError,
		formState: { errors },
	} = useForm()

	const validation = useCallback(
		data => {
			setLoading(true)
			formValidate(formId, data)
				.then(data => setSuccess(data.message))
				.catch(err => {
					err.invalid_fields.forEach(value => {
						setError(value.field, {
							type: 'manual',
							message: value.message,
						})
					})
					setSuccess(false)
				})
				.finally(() => {
					setLoading(false)
				})
		},
		[formId, setError]
	)

	if (error) return <></>

	return components ? (
		<motion.section className="contato">
			<motion.span
				className="contato__identifier"
				id={data.identificacao}
			></motion.span>
			<div className="contato__wrapper wrapper">
				{components.title ? (
					<Title
						initial={{
							color: '#01005d',
							opacity: 0,
							x: -20,
						}}
						style={{
							marginBottom: '8rem',
							y: parallax,
						}}
						whileInView={{
							opacity: 1,
							x: 0,
							transition: {
								duration: 1.5,
								bounce: 0.5,
								type: 'spring',
							},
						}}
						viewport={{
							margin: '0px 0px -50px 0px',
							once: 'true',
						}}
						dangerouslySetInnerHTML={{ __html: data.title }}
					></Title>
				) : (
					<></>
				)}
				<motion.form
					initial={{ opacity: 0 }}
					whileInView={{ opacity: 1 }}
					viewport={{ margin: '-10%' }}
					className="contato__form"
					style={{ y: parallax }}
					onSubmit={handleSubmit(validation)}
				>
					{components.properties.form.fields.map((field, i) => {
						const options = field.options.map((v, i) =>
							JSON.parse(`{"${v}":"${field.values[i]}"}`)
						)
						const props = options.reduce(function (acc, x) {
							for (var key in x) acc[key] = x[key]
							return acc
						}, {})

						switch (field.type) {
							case 'textarea':
								return (
									<InputWrapper
										name={field.name}
										key={field.name}
										{...props}
										errorMessage={
											errors[field.name]
												? errors[field.name].message
												: false
										}
									>
										<TextArea
											{...register(field.name)}
											disabled={loading}
											{...props}
											key={field.name + 'Input'}
										/>
									</InputWrapper>
								)
							case 'submit':
								return (
									<Button
										key={field.type + i}
										type={field.type}
										disabled={loading}
										{...props}
									>
										Enviar
									</Button>
								)
							default:
								return (
									<InputWrapper
										name={field.name}
										key={field.name}
										{...props}
										errorMessage={
											errors[field.name]
												? errors[field.name].message
												: false
										}
									>
										<Input
											{...register(field.name)}
											type={field.type}
											key={field.name + 'Input'}
											disabled={loading}
											{...props}
										/>
									</InputWrapper>
								)
						}
					})}
					<AnimatePresence>
						{success ? (
							<motion.span
								initial={{ opacity: 0, y: 15 }}
								animate={{ opacity: 1, y: 0 }}
								exit={{ opacity: 0, y: 15 }}
								className="contato__success"
								key="success"
							>
								{success}
							</motion.span>
						) : (
							<></>
						)}
					</AnimatePresence>
				</motion.form>
			</div>
		</motion.section>
	) : (
		<></>
	)
}
